export default __webpack_public_path__ + "26491216fc893f58d700c300fe8589a7.svg";